import './index.css';
import {useLocation} from "react-router-dom";
import {sendFlutterMessage, goBack, insets} from "../../util";
import ArrowBackDark from '../../images/arrow-back-dark.png';
import ArrowBackLight from '../../images/arrow-back-light.png';
import {useEffect, useState} from "react";

export default ({title, suffix, dark = false, border = false, absolute = false, scrollRef, ...props}) => {
    const location = useLocation();
    const paddingTop = insets.paddingTop === 0 ? 0 : insets.paddingTop - 20;
    const [opacity, setOpacity] = useState(0);

    useEffect(() => {
        if (!scrollRef) return;

        // 添加滚动监听
        scrollRef.current.addEventListener('scroll', handleScroll, {passive: true}); // passive模式提升性能[4](@ref)
        // 组件卸载时清理
        return () => {
            if (scrollRef.current) {
                scrollRef.current.removeEventListener('scroll', handleScroll);
            }
        };
    }, []);

    const handleScroll = () => {
        const container = scrollRef.current;
        // 获取容器内的滚动位置和尺寸[2,4](@ref)
        const scrollTop = container.scrollTop;
        const scrollHeight = container.scrollHeight;
        const clientHeight = container.clientHeight;
        const maxScroll = scrollHeight - clientHeight;

        // 仅当内容可滚动时计算透明度
        if (maxScroll > 0) {
            // 计算滚动比例 (0~1)
            const scrollRatio = scrollTop / maxScroll;
            // 向上滚动时透明度降低[6](@ref)
            const newOpacity = Math.min(10, Math.max(0, scrollRatio * 100)) * 10;
            setOpacity(newOpacity);
        }
    };

    const onBack = () => {
        if (location.pathname === '/')
            sendFlutterMessage(goBack);
        else
            window.history.back(-1);
    }

    const customStyle = {
        marginTop: absolute ? '' : `${paddingTop}px`,
        paddingTop: absolute ? `${20 + paddingTop}px` : '',
        background: `rgba(255,255,255, ${scrollRef ? opacity / 100 : 0})`,
    };

    return (
        <div
            className={`custom-navigate${border ? ' custom-border-navigate' : ''}${absolute ? ' custom-absolute' : ''}${opacity > 0.5 ? ' light-navigate' : ''}`}
            style={customStyle} {...props}>
            <img className='back-img' onClick={onBack} src={dark || opacity > 0.5 ? ArrowBackDark : ArrowBackLight}
                 alt=""/>
            <span className='title'>{title}</span>
            <div>{suffix}</div>
        </div>
    )
}